import React from 'react';
import about_us from '../../assests/img/about-us.jpg';

const DownloadBrochure = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>About Us</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="http://kcmschoolbass.com/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    About Us
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={about_us} alt="About Us" width="100%" />
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    We are a young and budding educational institution who
                                                    believe in domestic system in education, and not in the
                                                    mechanical methods of large production in institutions
                                                    turning students into standardised articles. We believe
                                                    the making of a man depends on the human factors...
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    In consonance with the Upanishadic idea, individual is
                                                    the chief concern and centre of our education, and
                                                    education also is necessarily individual centric...
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    At KCMS, the personal touch, the living relationship
                                                    between the pupil and the teacher make education...
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    The school will provide an engrossing and riveting
                                                    environment for learners and offers a broad-based
                                                    curriculum...
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    KCMS envisions learning and education rooted in Indian
                                                    ethos and ideas for an equitable and vibrant knowledge
                                                    society...
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="online-registration" target="_self" className="submenu">
                                                        Online Registration                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="admission-procedure"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Admission Procedure
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="fees-structure" target="_self" className="submenu">
                                                        Fees Structure
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="download-brochure" className="submenu">
                                                        Download Brochure
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button>
                    </div>
                </div>
            </div >
        </>
    )
}

export default DownloadBrochure;